module.exports = __webpack_public_path__ + "img/logo.c149658d.svg";